import { useOpenDrawerResource } from '@ctw/shared/hooks/use-open-drawer-resource';
import { useCallback } from 'react';

interface OpenDrawerResourceRow {
  resourceType: string;
  id: string;
}

/**
 * Returns a predicate identifying the record whose drawer or modal is currently open, so a row
 * list can highlight it. `explicitIsRowSelected` overrides the default open-drawer-resource
 * comparison for callers (e.g. `PatientDocuments`) that track the open resource themselves.
 */
export const useIsOpenDrawerResourceRow = <T extends OpenDrawerResourceRow>(
  explicitIsRowSelected?: (record: T) => boolean,
): ((record: T) => boolean) => {
  const openDrawerResource = useOpenDrawerResource();

  return useCallback(
    (record: T) =>
      explicitIsRowSelected
        ? explicitIsRowSelected(record)
        : record.resourceType === openDrawerResource?.resourceType &&
          record.id === openDrawerResource?.id,
    [explicitIsRowSelected, openDrawerResource?.resourceType, openDrawerResource?.id],
  );
};
